// extracted by mini-css-extract-plugin
export var editInput = "_j6-0";
export var editInputCompact = "_j6-2";
export var editInputLarge = "_j6-1";
export var editInputSmall = "_j6-3";